import { registerPlugin } from '@capacitor/core'

export interface BLEPlugin {
  getQlocxPeripherals(): Promise<{ peripherals: string[]; logEntries: [] }>
  executePayloads(obj: BLE): Promise<{ logEntries: []; result: string[] }>
}

const BLE = registerPlugin<BLEPlugin>('BLE')

export default BLE
